import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		announcementSlugs: ["novita", "novitÃ "],
		articleSlugs: ["articoli", "articolo"],
		colorsObject: {
			all: "#497dd6",
			adults: "#eb6a6a",
			schools: "#974fe0",
			childs: "#36bf88",
			family: "#fdad47",
		},
		columnWidth: 40,
		currentRoute: null,
		dotsNumberX: 0,
		dotsNumberY: 0,
		emailForSubscribe: null,
		infoOpeningTime: null,
		infoSubscription: {},
		isAdult: false,
		isSubmitButtonVisible: false,
		municipalities: null,
		pageTitles: null,
		defaultUrlImage: "https://bibliotecaagora.it/wp-content/uploads/2020/10/AGORA20_social.png",
		defaultMetaKeywords: "",
		reportageSlugs: ["reportage", "reportages"],
		reviewSlugs: ["recensioni", "recensione"],
		slidingPagesSlug: null,
		subscriptionDialog: false,
		contactsDialog: false,
		menuMobile: false,
		droppedMenu: false,
		timeoutedMenu: false,
		loadingStatus: false,
		subscriptionFormList: {},
		
		// 🍪 NUOVO: STATO COOKIE
		cookieBannerVisible: false,
		cookieConsent: {
			necessary: true, // Sempre true, sono cookie necessari
			analytics: false, // Google Analytics
			functionality: false // Google Maps e YouTube
		},
		
		slugConverter: {
			adulti: "adults",
			"bambini-e-famiglie": "family",
			ragazzi: "childs",
			scuole: "schools",
			tutti: "all",
			adults: "adulti",
			childs: "ragazzi",
			family: "bambini-e-famiglie",
			schools: "scuole",
			all: "tutti",
		},
		validationRules: {
			cap: (value) => {
				const pattern = /^\d{5}$/;
				return pattern.test(value) || "CAP non valido.";
			},
			required: (value) => !!value || "Campo obbligatorio.",
			email: (value) => {
				const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return pattern.test(value) || "E-mail non valida.";
			},
		},
	},
	mutations: {
		updateProperty(state, { property, value }) {
			state[property] = value;
		},
		
		// 🍪 NUOVE MUTATIONS PER COOKIE
		setCookieBannerVisible(state, visible) {
			state.cookieBannerVisible = visible;
		},
		setCookieConsent(state, { type, value }) {
			state.cookieConsent[type] = value;
		},
		setAllCookieConsent(state, consents) {
			state.cookieConsent = { ...state.cookieConsent, ...consents };
		},
	},
	actions: {
		updateProperty(context, { property, value }) {
			context.commit("updateProperty", { property, value });
		},
		
		// 🍪 NUOVE ACTIONS PER COOKIE
		showCookieBanner({ commit }) {
			commit("setCookieBannerVisible", true);
		},
		hideCookieBanner({ commit }) {
			commit("setCookieBannerVisible", false);
		},
		updateCookieConsent({ commit }, { type, value }) {
			commit("setCookieConsent", { type, value });
			// Salva nel localStorage
			const consents = JSON.parse(localStorage.getItem("cookieConsent") || "{}");
			consents[type] = value;
			localStorage.setItem("cookieConsent", JSON.stringify(consents));
		},
		acceptAllCookies({ commit }) {
			const consents = {
				necessary: true,
				analytics: true,
				functionality: true
			};
			commit("setAllCookieConsent", consents);
			commit("setCookieBannerVisible", false);
			localStorage.setItem("cookieConsent", JSON.stringify(consents));
			localStorage.setItem("cookieConsentGiven", "true");
		},
		rejectOptionalCookies({ commit }) {
			const consents = {
				necessary: true,
				analytics: false,
				functionality: false
			};
			commit("setAllCookieConsent", consents);
			commit("setCookieBannerVisible", false);
			localStorage.setItem("cookieConsent", JSON.stringify(consents));
			localStorage.setItem("cookieConsentGiven", "true");
		},
		loadCookieConsent({ commit, dispatch }) {
			// Controlla se l'utente ha già dato il consenso
			const consentGiven = localStorage.getItem("cookieConsentGiven");
			
			if (consentGiven) {
				// Carica i consensi salvati
				const savedConsents = JSON.parse(localStorage.getItem("cookieConsent") || "{}");
				commit("setAllCookieConsent", {
					necessary: true,
					analytics: savedConsents.analytics || false,
					functionality: savedConsents.functionality || false
				});
			} else {
				// Se non ha mai dato il consenso, mostra il banner
				dispatch("showCookieBanner");
			}
		}
	},
	getters: {
		// 🍪 NUOVO: GETTER PER VERIFICARE SE UN COOKIE È ACCETTATO
		hasCookieConsent: (state) => (type) => {
			return state.cookieConsent[type] === true;
		}
	}
});